import ODOptimizationTable from './table'

export default ODOptimizationTable
